import { combineReducers } from 'redux';

import walletReducer from './wallet/reducer';
import paginatedBlocksReducer from './paginated-blocks/reducer';
import paginatedDeploysReducer from './paginated-deploys/reducer';
import accountDelegationsReducer from './account-delegations/reducer';
import activeAccountDelegationsReducer from './active-account-delegations/reducer';
import currencyReducer from './fiat-currencies/reducer';
import themeReducer from './theme/reducer';
import featureSpotlightsReducer from './feature-spotlights/reducer';
import activityExportReducer from './activity-export/reducer';

const rootReducer = combineReducers({
  wallet: walletReducer,
  paginatedBlocks: paginatedBlocksReducer,
  paginatedDeploys: paginatedDeploysReducer,
  accountDelegations: accountDelegationsReducer,
  activeAccountDelegations: activeAccountDelegationsReducer,
  currencies: currencyReducer,
  theme: themeReducer,
  featureSpotlights: featureSpotlightsReducer,
  activityExport: activityExportReducer,
});

export default rootReducer;
